import { createContext } from 'react';
import { DEFAULT_MAINTENANCE_PACKAGE_CONTEXT } from './constants/defaultContext';

export const MaintenancePackageContext = createContext(
    DEFAULT_MAINTENANCE_PACKAGE_CONTEXT
);
